export default {
  creditCheckWrapperMargin: '0',
  checkMarkTextFontSize: '0.8rem',
};
